module.exports = __webpack_public_path__ + "img/sad.7b49a330.svg";